import { Component, OnInit , Input, AfterContentInit} from '@angular/core';
import { ParagraphBlockItem } from '../../../../core/models/physician/form-doc-builder';

@Component({
  selector: 'app-form-block-paragraph',
  templateUrl: './form-block-paragraph.component.html',
  styleUrls: ['./form-block-paragraph.component.scss']
})
export class FormBlockParagraphComponent implements OnInit, AfterContentInit {
  @Input() blockItem: ParagraphBlockItem;

  constructor() { }

  ngOnInit() {
  }
  ngAfterContentInit() {
    if (!this.blockItem.type) {
      this.blockItem.type = 2;
    }
  }
}
